/*
Pigmented Primers
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Pigmented Primers'
const id = 'Vf8wqxRKrRLu3VP34kfD'

export default {
  name,
  id,
  filters,
  headers,
  form
}
